import schedulingGroups from '../config/schedulingGroups';

// Um usuário pode acumular grupos (ex.: Admin + Manager). Papéis restritivos
// (Manager, CoManager, TechLab) só restringem quem não tem um grupo irrestrito.
// Espelho de api/src/app/utils/access.ts — manter os dois iguais.
const UNRESTRICTED_GROUPS = [schedulingGroups.Admin];

export const hasAnyScope = (scopes = [], groups) =>
  scopes.some(scope => groups.includes(scope));

export const isUnrestricted = (scopes = []) =>
  hasAnyScope(scopes, UNRESTRICTED_GROUPS);

export const isRestrictedTo = (scopes = [], groups) =>
  !isUnrestricted(scopes) && hasAnyScope(scopes, groups);
